'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWidgetBotResponder = undefined;

var _reselect = require('reselect');

var _getBotResponder = require('conversations-schema/operators/widget-data/getBotResponder');

var _getWidgetData = require('./getWidgetData');

var getWidgetBotResponder = exports.getWidgetBotResponder = (0, _reselect.createSelector)([_getWidgetData.getWidgetData], _getBotResponder.getBotResponder);


//////////////////
// WEBPACK FOOTER
// ./js/selectors/widgetDataSelectors/getWidgetBotResponder.js
// module id = 275
// module chunks = 2 3